import { Component, OnInit } from '@angular/core';
import { TechnicalsService } from '../../_services';
import { DownloadWithToastsService } from '../_shared/download-with-toasts';
import * as moment from 'moment';

@Component({
    selector: 'jhi-technicals',
    templateUrl: './technical.component.html',
    styleUrls: ['./technical.component.scss'],
})
export class TechnicalComponent implements OnInit {
    data: any;

    constructor(
        private technicalsService: TechnicalsService,
        private downloadService: DownloadWithToastsService
    ) {
        this.data = {};

        this.initExportSessions();
        this.initExportStaffingHistory();
        this.initExportContactableStudents();
        this.initExportRegistrations();
        this.initExportEvaluations();
        this.initExportTrainers();
        this.initExportStatsSession();
        this.initExportEvaluationsBySession();
        this.initMailQueueSize();
        this.initBddDumps();
    }

    ngOnInit() {}

    private initExportTrainers() {
        if (!this.data.export) {
            this.data.export = {};
        }

        this.data.export.trainers = {};
    }

    async downloadCAExport(
        selectedFromYear: number,
        selectedFromMonth: number,
        selectedToYear: number,
        selectedToMonth: number,
        exportType: string,
        type: string,
        fileName: string
    ) {
        await this.downloadDocument(
            `/api/training-sessions-csv?from=${this.getFormatedDate(
                selectedFromYear,
                selectedFromMonth
            )}&to=${this.getFormatedDate(
                selectedToYear,
                selectedToMonth
            )}&type=${exportType}`,
            type,
            fileName
        );
    }

    async downloadTrainerSkills(type: string, fileName: string) {
        await this.downloadDocument(`/api/trainers/skills.csv`, type, fileName);
    }

    async downloadStaffingHistory(
        selectedFromYear: number,
        selectedFromMonth: number,
        selectedToYear: number,
        selectedToMonth: number,
        type: string,
        fileName: string
    ) {
        await this.downloadDocument(
            `/api/sessions/staffingHistory.csv?from=${this.getFormatedDate(
                selectedFromYear,
                selectedFromMonth
            )}&to=${this.getFormatedDate(selectedToYear, selectedToMonth)}`,
            type,
            fileName
        );
    }

    async downloadContactableStudents(
        selectedFromYear: number,
        selectedFromMonth: number,
        selectedToYear: number,
        selectedToMonth: number,
        type: string,
        fileName: string
    ) {
        await this.downloadDocument(
            `/api/students/contactable.csv?from=${this.getFormatedDate(
                selectedFromYear,
                selectedFromMonth
            )}&to=${this.getFormatedDate(selectedToYear, selectedToMonth)}`,
            type,
            fileName
        );
    }

    async downloadRegistrations(
        selectedFromYear: number,
        selectedFromMonth: number,
        selectedToYear: number,
        selectedToMonth: number,
        type: string,
        fileName: string
    ) {
        await this.downloadDocument(
            `/api/registrations-csv?from=${this.getFormatedDate(
                selectedFromYear,
                selectedFromMonth
            )}&to=${this.getFormatedDate(selectedToYear, selectedToMonth)}`,
            type,
            fileName
        );
    }

    async downloadGrades(
        selectedFromYear: number,
        selectedFromMonth: number,
        selectedToYear: number,
        selectedToMonth: number,
        type: string,
        fileName: string
    ) {
        await this.downloadDocument(
            `/api/evaluations-lowest-csv?from=${this.getFormatedDate(
                selectedFromYear,
                selectedFromMonth
            )}&to=${this.getFormatedDate(selectedToYear, selectedToMonth)}`,
            type,
            fileName
        );
    }

    async downloadSessionStats(
        selectedFromYear: number,
        selectedFromMonth: number,
        selectedToYear: number,
        selectedToMonth: number,
        type: string,
        fileName: string
    ) {
        await this.downloadDocument(
            `/api/sessions/stats_by_year_and_training_and_trainer_company.csv?from=${this.getFormatedDate(
                selectedFromYear,
                selectedFromMonth
            )}&to=${this.getFormatedDate(selectedToYear, selectedToMonth)}`,
            type,
            fileName
        );
    }

    async downloadEvaluationsBySession(
        selectedFromYear: number,
        selectedFromMonth: number,
        selectedToYear: number,
        selectedToMonth: number,
        type: string,
        fileName: string
    ) {
        await this.downloadDocument(
            `/api/sessions/evaluations.csv?from=${this.getFormatedDate(
                selectedFromYear,
                selectedFromMonth
            )}&to=${this.getFormatedDate(selectedToYear, selectedToMonth)}`,
            type,
            fileName
        );
    }

    async downloadTrainersTrainingReport(type: string, fileName: string) {
        await this.downloadDocument(`/api/trainers-csv`, type, fileName);
    }

    async downloadDocument(route: string, type: string, fileName: string) {
        await this.downloadService.downloadAndOpenDocument(
            route,
            type,
            fileName
        );
    }

    private getFormatedDate(year: number, month: number) {
        return year + '-' + (month < 10 ? '0' + month : month);
    }

    private initExportEvaluations() {
        if (!this.data.export) {
            this.data.export = {};
        }

        this.data.export.evaluations = {
            selectedYear: '',
            selectedMonth: '',
            years: [],
            months: [],
        };

        let now = moment();

        this.data.export.evaluations.selectedFromYear = now.year();
        this.data.export.evaluations.selectedFromMonth = now.month() + 1;

        let monthPlusOne = moment().add(1, 'month');

        this.data.export.evaluations.selectedToYear = now.year();
        this.data.export.evaluations.selectedToMonth = now.month() + 1;

        for (let i = 0; i >= -10; i--) {
            this.data.export.evaluations.years.push(
                this.data.export.evaluations.selectedToYear + i
            );
        }
        for (let i = 1; i <= 12; i++) {
            this.data.export.evaluations.months.push({
                value: i,
                label: moment()
                    .month(i - 1)
                    .format('MMMM'),
            });
        }
    }

    private initExportSessions() {
        if (!this.data.export) {
            this.data.export = {};
        }

        this.data.export.sessions = {
            selectedYear: '',
            selectedMonth: '',
            years: [],
            months: [],
        };

        let now = moment();

        this.data.export.sessions.selectedFromYear = now.year();
        this.data.export.sessions.selectedFromMonth = now.month() + 1;

        this.data.export.sessions.selectedToYear = now.year();
        this.data.export.sessions.selectedToMonth = now.month() + 1;

        for (let i = 1; i >= -10; i--) {
            this.data.export.sessions.years.push(
                this.data.export.sessions.selectedFromYear + i
            );
        }
        for (let i = 1; i <= 12; i++) {
            this.data.export.sessions.months.push({
                value: i,
                label: moment()
                    .month(i - 1)
                    .format('MMMM'),
            });
        }
    }

    private initExportStaffingHistory() {
        if (!this.data.export) {
            this.data.export = {};
        }

        this.data.export.staffingHistory = {
            selectedYear: '',
            selectedMonth: '',
            years: [],
            months: [],
        };

        let now = moment();

        this.data.export.staffingHistory.selectedFromYear = now.year();
        this.data.export.staffingHistory.selectedFromMonth = now.month() + 1;

        let monthPlusOne = moment().add(1, 'month');

        this.data.export.staffingHistory.selectedToYear = now.year();
        this.data.export.staffingHistory.selectedToMonth = now.month() + 1;

        for (let i = 0; i >= -10; i--) {
            this.data.export.staffingHistory.years.push(
                this.data.export.staffingHistory.selectedFromYear + i
            );
        }
        for (let i = 1; i <= 12; i++) {
            this.data.export.staffingHistory.months.push({
                value: i,
                label: moment()
                    .month(i - 1)
                    .format('MMMM'),
            });
        }
    }

    private initExportContactableStudents() {
        if (!this.data.export) {
            this.data.export = {};
        }

        this.data.export.contactableStudents = {
            selectedYear: '',
            selectedMonth: '',
            years: [],
            months: [],
        };

        let now = moment();

        this.data.export.contactableStudents.selectedFromYear = now.year();
        this.data.export.contactableStudents.selectedFromMonth =
            now.month() + 1;

        let monthPlusOne = moment().add(1, 'month');

        this.data.export.contactableStudents.selectedToYear = now.year();
        this.data.export.contactableStudents.selectedToMonth = now.month() + 1;

        for (let i = 0; i >= -10; i--) {
            this.data.export.contactableStudents.years.push(
                this.data.export.contactableStudents.selectedFromYear + i
            );
        }
        for (let i = 1; i <= 12; i++) {
            this.data.export.contactableStudents.months.push({
                value: i,
                label: moment()
                    .month(i - 1)
                    .format('MMMM'),
            });
        }
    }

    private initExportRegistrations() {
        if (!this.data.export) {
            this.data.export = {};
        }

        this.data.export.registrations = {
            selectedYear: '',
            selectedMonth: '',
            years: [],
            months: [],
        };

        let now = moment();

        this.data.export.registrations.selectedFromYear = now.year();
        this.data.export.registrations.selectedFromMonth = now.month() + 1;

        let monthPlusOne = moment().add(1, 'month');

        this.data.export.registrations.selectedToYear = now.year();
        this.data.export.registrations.selectedToMonth = now.month() + 1;

        for (let i = 0; i >= -10; i--) {
            this.data.export.registrations.years.push(
                this.data.export.registrations.selectedFromYear + i
            );
        }
        for (let i = 1; i <= 12; i++) {
            this.data.export.registrations.months.push({
                value: i,
                label: moment()
                    .month(i - 1)
                    .format('MMMM'),
            });
        }
    }

    private initExportStatsSession() {
        if (!this.data.export) {
            this.data.export = {};
        }

        this.data.export.sessionStats = {
            selectedYear: '',
            selectedMonth: '',
            years: [],
            months: [],
        };

        let now = moment();

        this.data.export.sessionStats.selectedFromYear = now.year();
        this.data.export.sessionStats.selectedFromMonth = now.month() + 1;

        let monthPlusOne = moment().add(1, 'month');

        this.data.export.sessionStats.selectedToYear = now.year();
        this.data.export.sessionStats.selectedToMonth = now.month() + 1;

        for (let i = 0; i >= -10; i--) {
            this.data.export.sessionStats.years.push(
                this.data.export.sessionStats.selectedFromYear + i
            );
        }
        for (let i = 1; i <= 12; i++) {
            this.data.export.sessionStats.months.push({
                value: i,
                label: moment()
                    .month(i - 1)
                    .format('MMMM'),
            });
        }
    }

    private initExportEvaluationsBySession() {
        if (!this.data.export) {
            this.data.export = {};
        }

        this.data.export.evaluationsBySession = {
            selectedYear: '',
            selectedMonth: '',
            years: [],
            months: [],
        };

        let now = moment();

        this.data.export.evaluationsBySession.selectedFromYear = now.year();
        this.data.export.evaluationsBySession.selectedFromMonth =
            now.month() + 1;

        let monthPlusOne = moment().add(1, 'month');

        this.data.export.evaluationsBySession.selectedToYear = now.year();
        this.data.export.evaluationsBySession.selectedToMonth = now.month() + 1;

        for (let i = 0; i >= -10; i--) {
            this.data.export.evaluationsBySession.years.push(
                this.data.export.evaluationsBySession.selectedFromYear + i
            );
        }
        for (let i = 1; i <= 12; i++) {
            this.data.export.evaluationsBySession.months.push({
                value: i,
                label: moment()
                    .month(i - 1)
                    .format('MMMM'),
            });
        }
    }

    private initMailQueueSize() {
        this.data.mail = {
            size: '',
        };

        this.technicalsService
            .findMailQueueSize()
            .subscribe((size) => (this.data.mail.size = size));
    }

    private initBddDumps() {
        this.data.bdd = {
            filenames: [],
            filenames5Firsts: [],
            showAll: false,
        };

        this.technicalsService.findBddDumps().subscribe((filenames) => {
            filenames = filenames.sort((f1, f2) => {
                return f1.localeCompare(f2);
            });
            filenames.reverse();
            this.data.bdd.filenames = filenames;
            this.data.bdd.filenames5Firsts = filenames.slice(0, 4);
        });

        this.data.bdd.showAllClick = () => {
            this.data.bdd.showAll = true;
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/technical/technical.component.ts